"use strict";

exports.__esModule = true;
exports.LocaleMenuItem = LocaleMenuItem;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
var _Locale = require("../../Env/Locale");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function LocaleMenuItem() {
  var _useContext = (0, _react.useContext)(_Translator.TranslatorContext),
    translate = _useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    text: translate("SettingsMenu.Language", "Language"),
    shouldDismissPopover: false,
    popoverProps: {
      openOnTargetFocus: false
    }
  }, Object.keys(_Locale.SUPPORTED_LOCALES).map(function (lang) {
    var locale = _Locale.SUPPORTED_LOCALES[lang];
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      shouldDismissPopover: false,
      text: locale.longName + " (" + lang + ")",
      key: locale.language,
      onClick: function onClick() {
        localStorage.setItem(_Locale.STORAGE_LOCALE_KEY, lang);
        window.location.reload();
      }
    });
  }));
}